import * as React from "react";
import { Button } from "@progress/kendo-react-buttons";

export const CommandCell = (props) => {
    const { dataItem } = props;

    const inEdit = dataItem[props.editField];
    const keyValue = dataItem[props.keyField];
    const isNewItem = keyValue === undefined;

    return inEdit ? (
        <td className="k-command-cell">
            <Button
                icon="save"
                onClick={() =>
                    isNewItem ? props.add(dataItem) : props.update(dataItem)
                }
            >
                Save
            </Button>
            &nbsp;
            <Button
                icon="cancel"
                onClick={() =>
                    isNewItem ? props.discard(dataItem) : props.cancel(dataItem)
                }
            >
                Cancel
            </Button>
        </td>
    ) : (
        <td className="k-command-cell">
            {props.canEdit === false ? <></> :
                <>
                    <Button
                        className="k-grid-edit-command"
                        themeColor={"primary"}
                        icon="edit"
                        onClick={() => props.edit(dataItem)}
                    >
                        Edit
                    </Button>
                    &nbsp;
                </>
            }
            {props.canDelete === false ? <></> :
                <Button
                    icon="delete"
                    onClick={() =>
                        window.confirm("Are you sure you want to delete this item?") &&
                        props.remove(dataItem)
                    }
                >
                    Delete
                </Button>
            }
        </td>
    );
};